import React from 'react'
import { FooterWidget } from 'plugins/footer'
import pulse from '@blocket/tracking-pulse'
import { isAppRoute } from 'paths'

const Footer = () => {
  const trackFooterNavigation = (e, name) => {
    if (name) {
      pulse.event({
        type: 'Engagement',
        name: 'Footer',
        object: { type: 'UIElement', id: 'footer-navigation' },
        target: { id: name.toLowerCase(), type: 'Page' },
      })
    }
  }

  return <FooterWidget trackFooterNavigation={trackFooterNavigation} isAppRoute={isAppRoute} />
}

export default Footer
